import { render, staticRenderFns } from "./operateGuideCategory.vue?vue&type=template&id=d065d73e&scoped=true&"
import script from "./operateGuideCategory.vue?vue&type=script&lang=js&"
export * from "./operateGuideCategory.vue?vue&type=script&lang=js&"
import style0 from "./operateGuideCategory.vue?vue&type=style&index=0&id=d065d73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d065d73e",
  null
  
)

export default component.exports